import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/create/layer.create.sourceUsage.query.gql"
import type {
  LayerSourceUsageQuery,
  LayerSourceUsageQueryVariables,
} from "@/v2-backoffice-client/layer/create/__types__/layer.create.sourceUsage.query"

type Options = QueryHookOptions<
  LayerSourceUsageQuery,
  LayerSourceUsageQueryVariables
>

export function useLayerSourceUsageQuery(options?: Options) {
  return useQuery<LayerSourceUsageQuery, LayerSourceUsageQueryVariables>(
    query,
    options,
  )
}
